import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { customFetch } from "../../utils/custom-fetch.js";
import Wrapper from "../../assets/wrappers/DashboardFormPage.js";

const ManagerFormModal = ({ setMaintenanceCompanyId, closeModal, handleSave }) => {
  const [maintenanceCompanies, setMaintenanceCompanies] = useState([]);

  useEffect(() => {
    loadMaintenanceCompanies();
  }, []);

  const handleManagerDetailChange = (selectedOption) => {
    setMaintenanceCompanyId(selectedOption.value);
  };

  const loadMaintenanceCompanies = async () => {
    try {
      const response = await customFetch.get('/buildings/maintenance-companies');
      const companies = response.data.map(company => ({
        value: company.value,
        label: company.name
      }));
      setMaintenanceCompanies(companies);
    } catch (error) {
      console.error(error);
      toast.error("שגיאה בטעינת חברות האחזקה");
    }
  };

  return (
    <Wrapper className="modal">
      <div className="modal-content">
        <h4>פרטי וועד הבית</h4>
        <Select
          options={maintenanceCompanies}
          name="maintenanceCompany"
          onChange={handleManagerDetailChange}
          placeholder="בחר חברת אחזקה"
        />
        <div className="modal-actions">
          <button type="button" className="btn" onClick={handleSave}>
            שמירה
          </button>
          <button type="button" className="btn danger-btn" onClick={closeModal}>
            ביטול
          </button>
        </div>
      </div>
    </Wrapper>
  );
};

export default ManagerFormModal;
